<template>
  <div>
    <div class="eu-flex eu-column eu-row_xl eu-align-items_center">
      <div class="eu-flex-item">
        <emd-button
          color="secondary"
          type="link"
          @click="togglePixModal"
        >
          <span class="uil uil-qrcode-scan">{{
            $t('charge.detail.payment-method.pix.view-qr-code')
          }}</span>
        </emd-button>
      </div>

      <div class="eu-flex-item">
        <emd-button
          class="eu-mr_1"
          color="secondary"
          type="link"
          @click="copyToClipboard(qrCodeUrl)"
        >
          <span class="uil uil-copy"></span>
          {{ $t('charge.detail.payment-method.pix.copy-qr-code') }}
        </emd-button>
        <span
          class="emd-badge eu-ml_2 _color_secondary"
          :class="{ 'eu-hidden': !copyQrCode }"
        >
          {{ $t('charge.detail.payment-method.pix.copy') }}
        </span>
      </div>
    </div>

    <PixModal
      :charge-id="chargeId"
      :qr-code-url="qrCodeUrl"
      :open="pixModalOpen"
      @handleOpen="() => (pixModalOpen = $event)"
    />
  </div>
</template>

<script>
import { EmdButton } from 'emerald-vue/src/components'
export default {
  name: 'ChargesPaymentMethodPixFirstTransaction',

  components: {
    EmdButton,
    PixModal: () => import('./PixModal.vue')
  },

  props: {
    chargeId: {
      required: true
    },
    qrCodeUrl: {
      required: true
    }
  },

  data () {
    return {
      copyQrCode: false,
      pixModalOpen: false,
      debounceTimer: undefined
    }
  },

  methods: {
    togglePixModal () {
      this.pixModalOpen = !this.pixModalOpen
    },
    copyToClipboard (value) {
      this.$copyText(value).then(() => {
        this.copyQrCode = true
        clearTimeout(this.debounceTimer)
        this.debounceTimer = setTimeout(() => {
          this.copyQrCode = false
        }, 1000)
      })
    }
  }
}
</script>
